/* ==========================================================================
   CASEMIRA · FICHE PRODUIT · LES DEUX RAILS VONT CHERCHER LEURS PRODUITS
   Fichier : assets/casemira-fiche-rails.js · 09/09/2026, chantier 7.

   Deux éléments personnalisés, `<casemira-fiche-aimerez>` et
   `<casemira-fiche-recents>`, qui reprennent LA MÉCANIQUE DE CHARGEMENT des
   sections du thème Hyper qu'ils remplacent (`assets/product-recommendations
   .js` et `assets/recently-viewed-products.js`) : même moment de départ, mêmes
   paramètres d'URL, même lecture du stockage local, même règle de retrait quand
   il n'y a rien à montrer. Ce qui change, c'est le RENDU : les cartes et le rail
   sont ceux des best-sellers de l'accueil.

   ───────────────────────────────────────────────────────────────────────────
   1 · POURQUOI NOS PROPRES ÉLÉMENTS, ET NON CEUX DU THÈME

   `product-recommendations` et `recently-viewed-products` finissent tous deux
   par la même ligne : « si la réponse ne contient pas de `.product-card`, retire
   la section ». Nos cartes ne portent pas cette classe (elles portent `.pcard
   .cm-card .carte`, celles de l'accueil) : les deux sections se seraient
   effacées elles-mêmes à chaque chargement. Il aurait fallu ajouter une classe
   décorative aux cartes pour tromper un test — c'est-à-dire écrire du balisage
   qui ne dit pas ce qu'il est.

   Les deux éléments du thème tirent en outre `product-slider.js` et le
   carrousel Swiper qui va avec, dont ces deux blocs n'ont plus l'usage.

   2 · LE MOMENT DU DÉPART, REPRIS À LA LETTRE

   `requestIdleCallback` avec un plafond de 1 500 ms, exactement comme Hyper ;
   à défaut, l'entrée dans le cadre à 400 px près. Le thème passe par
   `FoxTheme.Motion.inView` pour ce repli ; on prend l'IntersectionObserver
   directement, pour ne pas dépendre de l'ordre de chargement de `theme.js`.

   3 · LA LANGUE

   L'adresse de base est écrite par le Liquid, à partir de `routes.
   product_recommendations_url` et de `routes.search_url` : Shopify les rend
   déjà préfixées par la racine de langue. Le filet de la ligne `localiser()`
   n'est pas une méfiance gratuite, c'est la règle « Panier Ajax et langue » du
   06/09 prise au mot : une requête partie de `/en` qui reviendrait en français
   rendrait un rail entier dans la mauvaise langue, et rien à l'écran ne dirait
   pourquoi.

   4 · CE QUI ARRIVE APRÈS COUP DOIT ÊTRE MONTÉ

   Le rail reçu n'a ni flèches, ni jauge, ni cascade : ce sont des gestes de
   script. On annonce donc `cm:rail:monte` avec la racine `.cmh` qui vient
   d'arriver, et `assets/casemira-rail.js` la monte — le même chemin que les
   cinq corps différés de l'accueil, qui annoncent `cm:differe:charge`.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__cmFicheRailsFait) return;
  window.__cmFicheRailsFait = true;

  /* Le départ, repris de Hyper : au premier temps mort, plafonné à 1 500 ms ;
     à défaut, à l'approche du cadre. */
  function auCalme(el, faire) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(faire, { timeout: 1500 });
      return;
    }
    if (!('IntersectionObserver' in window)) { faire(); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        faire();
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  }

  /* LA RACINE DE LANGUE, ET LE FILET. `data-racine` porte `routes.root_url` :
     « / » en français, « /en », « /de », « /nl », « /es », « /it » ailleurs.
     Si l'adresse ne commence pas déjà par cette racine, on la lui donne. */
  function localiser(url, racine) {
    if (!racine || racine === '/') return url;
    if (url.indexOf(racine + '/') === 0 || url === racine) return url;
    if (url.charAt(0) !== '/') return url;
    return racine + url;
  }

  var Socle = {
    /* Le corps commun des deux éléments : demander, lire, poser, monter. */
    charger: function (el, url) {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (texte) {
          var section = new DOMParser().parseFromString(texte, 'text/html').querySelector('.shopify-section');
          if (section === null) return;

          var recu = section.querySelector(el.tagName.toLowerCase());
          /* LA MÊME RÈGLE QUE HYPER, AVEC NOTRE CARTE À LA PLACE DE LA SIENNE :
             une réponse sans une seule carte veut dire qu'il n'y a rien à
             montrer, et un bloc vide avec son titre est pire qu'un bloc absent. */
          if (!recu || !recu.querySelector('.pcard')) { Socle.retirer(el); return; }

          el.innerHTML = recu.innerHTML;

          var racine = el.querySelector('.cmh');
          if (racine) {
            document.dispatchEvent(new CustomEvent('cm:rail:monte', {
              bubbles: true,
              detail: { racine: racine, contenu: el }
            }));
          }
        })
        .catch(function (e) { console.error(e); });
    },

    /* Hyper retire la SECTION entière, pas seulement l'élément : sans cela, la
       respiration du bloc et son éventuel filet resteraient sur la page, sous
       la forme d'un blanc que personne ne s'explique. */
    retirer: function (el) {
      var section = el.closest ? el.closest('.shopify-section') : null;
      if (section) section.remove();
      else el.remove();
    }
  };

  /* ───────────────────────────────────────────────── VOUS AIMEREZ AUSSI
     `data-url` vaut « <racine de langue>/recommendations/products?section_id=
     …&product_id=…&limit=… », l'adresse que le thème construit déjà. L'API de
     recommandations de Shopify ne renvoie jamais le produit courant : c'est
     elle qui exclut, pas nous. */
  if (!customElements.get('casemira-fiche-aimerez')) {
    customElements.define('casemira-fiche-aimerez', class extends HTMLElement {
      connectedCallback() {
        if (this.__parti) return;
        this.__parti = true;
        var el = this;
        auCalme(el, function () {
          var url = el.dataset.url;
          if (!url) { Socle.retirer(el); return; }
          Socle.charger(el, localiser(url, el.dataset.racine));
        });
      }
    });
  }

  /* ─────────────────────────────────────────────── RÉCEMMENT CONSULTÉS
     La liste des produits vus est celle du thème, `hypertheme:recently-viewed`,
     écrite par `<product-recently-viewed>` dans `sections/main-product.liquid` :
     on la LIT, on ne l'écrit pas, et on ne change pas sa clé. Le produit courant
     en est retiré ici, avant la requête, exactement comme le fait Hyper.
     La requête est une recherche de produits par identifiants, dans l'ordre du
     parcours : `q=id:123 OR id:456`. */
  if (!customElements.get('casemira-fiche-recents')) {
    customElements.define('casemira-fiche-recents', class extends HTMLElement {
      connectedCallback() {
        if (this.__parti) return;
        this.__parti = true;
        var el = this;
        auCalme(el, function () {
          var url = el.requete();
          if (!url) { Socle.retirer(el); return; }
          Socle.charger(el, localiser(url, el.dataset.racine));
        });
      }

      requete() {
        var vus = [];
        try {
          vus = JSON.parse(window.localStorage.getItem('hypertheme:recently-viewed') || '[]');
        } catch (e) {
          vus = [];
        }
        if (!Array.isArray(vus) || !vus.length) return false;

        var courant = parseInt(this.dataset.produit, 10);
        var combien = parseInt(this.dataset.limite, 10) || 8;
        if (vus.indexOf(courant) !== -1) vus.splice(vus.indexOf(courant), 1);
        if (!vus.length) return false;

        return this.dataset.url + vus
          .slice(0, combien)
          .map(function (id) { return 'id:' + id; })
          .join(' OR ');
      }
    });
  }
})();
